import { render, staticRenderFns } from "./online_pay.vue?vue&type=template&id=4edf8881&scoped=true"
import script from "./online_pay.vue?vue&type=script&lang=js"
export * from "./online_pay.vue?vue&type=script&lang=js"
import style0 from "./online_pay.vue?vue&type=style&index=0&id=4edf8881&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf8881",
  null
  
)

export default component.exports